import React, {useEffect,useState} from "react";
import axios from "axios";
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import {Divider, Grid, TextField, Fab
} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import ErrorMsg from "../msg/ErrorMsg";
import SuccsMsg from "../msg/SuccsMsg";
const style2 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 300,
    bgcolor: 'background.paper',
    border: '1px solid #000',
    boxShadow: 10,
    p: 2,
    textAlign:'center',
    borderRadius : 2,
    maxHeight:'70%',
    overflowY:'auto',
    transaction:'1s',
};
const Createnewpishfactor = (
    {btnedit , setbtnedit , editkeycode , editcustomername , editcustomertel,isMobile}) =>{
    const [modalcreate , setModalcreate] = React.useState(false);
    const [iscustomername , setIscustomername] = React.useState([]);
    const [key , setKey] = React.useState("");
    const [total , setTotal] = React.useState([]);
    const [customername , setCustomername] = React.useState("");
    const [customertel , setCustomertel] = React.useState("");
    const [customerAddress , setCustomerAddress] = React.useState("");
    const [open, setOpen] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [errorMsg , setErrorMsg] = useState("");
    const [succsMsg , setSuccsMsg] = useState("");
    const navigate = useNavigate();
    useEffect(()=>{
        if (btnedit === true){
            handelcreatenewopen();
            setbtnedit(false);
        }
    },[btnedit])
    function generate_key() {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < 15; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
    }
    const handle_change_total = (event)=>{
        setCustomerAddress(event.target.value);
    }
    const handle_change_customername = (event)=>{
        setCustomername(event.target.value);
    }
    const handle_change_customertel = (event)=>{
        setCustomertel(toEnglishDigits(event.target.value));
    }
    function toEnglishDigits(str) {
            // convert persian digits [۰۱۲۳۴۵۶۷۸۹]
        var e = '۰'.charCodeAt(0);
        str = str.replace(/[۰-۹]/g, function(t) {
            return t.charCodeAt(0) - e;
        });

        // convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
        e = '٠'.charCodeAt(0);
        str = str.replace(/[٠-٩]/g, function(t) {
            return t.charCodeAt(0) - e;
        });
        return str;
    }
    const handelcreatenewopen = () => {
        if (btnedit)
        {
            if (editkeycode.length > 0){
                setModalcreate(true);
                setCustomername(editcustomername);
                setCustomertel(editcustomertel);
                setKey(editkeycode);
                setIscustomername(true);
            }
        }
        else
        {
            setModalcreate(true);
            setKey(generate_key());
        }

    }
    const handleClose = () => {
        if (open === false)
        {
            setModalcreate(false);

        }
        else
        {
            setOpen(false);
            setLoading(false);
        }

    }
    const hanlde_btn_speeddial =()=>{
        handelcreatenewopen();
    }
    const handle_btn_create = ()=>{
        if (customername !== "") {
            localStorage.removeItem("cstname");
            localStorage.removeItem("csttel");
            localStorage.removeItem("cstaddress");
            localStorage.removeItem("cstid");
            localStorage.removeItem("ftype");
            const data = {
                customername: customername,
                total: total,
                keyid: key,
            };
            axios.post('https://raumawood.com/app/api/get_createfactor.php', data)
                .then(respone => {
                    if (respone.data.status === "ok") {
                        localStorage.setItem('cstname', customername);
                        localStorage.setItem('csttel', customertel);
                        localStorage.setItem('cstaddress', customerAddress);
                        localStorage.setItem('cstid', "");
                        localStorage.setItem('ftype', "prefactor");
                        setKey(respone.data.key);

                        navigate('/factors/' + key, {replace: true});

                    }

                })
                .catch(error => console.log(error));
        }
        else
            setErrorMsg("نام مشتری را وارد کنید");
    }
    return(
        <div>

            <p>

            </p>
            {errorMsg !== '' ? <ErrorMsg message={errorMsg} openn={true} seterrormsg={setErrorMsg}/> : '' }
            {succsMsg !== '' ? <SuccsMsg message={succsMsg} openn={true} setsuccsmsg={setSuccsMsg} /> : '' }
            <div>
                <Fab
                    color="primary"
                    sx={{ position: 'fixed', bottom: 16, right: !isMobile?256:16 }}
                    onClick={hanlde_btn_speeddial}
                    aria-label="add">
                    <AddIcon />
                </Fab>
                <div>
                    <Modal
                        keepMounted
                        disableScrollLock
                        open={modalcreate}
                        onClose={handleClose}
                        aria-labelledby="keep-mounted-modal-title"
                        aria-describedby="keep-mounted-modal-description">
                        <Box sx={style2} >
                            <Typography
                                id="keep-mounted-modal-title"
                                variant="h6"
                                component="h2"
                                sx={{
                                    textAlign:'right'
                                }}
                            >
                                <Grid tem container spacing={3}>
                                    <Grid item xs={12}>
                                        <div style={{textAlign:'center' , fontFamily:'farsi'}}>پیش فاکتور</div>
                                    </Grid>

                                </Grid>
                            </Typography>
                            <Divider sx={{marginTop:1}} orientation="horizontal" flexItem />
                            <TextField
                                autoComplete='off'
                                type='text'
                                fullWidth
                                id="outlined-basic"
                                label="نام مشتری"
                                onChange={handle_change_customername}
                                value={customername}
                                variant="outlined" sx={{
                                marginTop:2,
                                marginBottom:1,
                            }} />
                            <TextField
                                autoComplete='off'
                                type="tel"
                                fullWidth
                                id="outlined-basic"
                                label="شماره تماس"
                                onChange={handle_change_customertel}
                                value={customertel}
                                variant="outlined" sx={{
                                marginTop:2,
                                marginBottom:1,
                            }} />
                            <TextField
                                autoComplete='off'
                                type='text'
                                fullWidth
                                id="outlined-basic"
                                label="آدرس"
                                onChange={handle_change_total}
                                variant="outlined" sx={{
                                marginTop:2,
                                marginBottom:1,
                            }} />
                            <div>
                                <Button
                                    variant="contained"
                                    fullWidth
                                    onClick={handle_btn_create}
                                >ایجاد فاکتور</Button>
                            </div>
                        </Box>
                    </Modal>
                </div>

            </div>
        </div>
    )
}
export default Createnewpishfactor